import { UTM_PROPERTIES } from '@shared/model/constants/contentTemplate'

const checkHasUtmProperties = (url: string) => {
  // 用 `${item}=` 是為了避免輸入 ?utm_sourcessss= 這種情境
  const conditions = UTM_PROPERTIES.map(item => url.includes(`${item}=`))
  return conditions.some(Boolean)
}

export default checkHasUtmProperties
